<template>
  <div class="ig-gallery">
    <div class="ig-gallery-grid">
      <div
        v-for="(item, idx) in items"
        :key="item.id"
        class="ig-gallery-item"
        @click="open(idx)"
      >
        <img :src="$store.state.fileBaseUrl + item.image" loading="lazy" alt="" />
        <div v-if="item.image_before" class="ig-compare-badge">
          <v-icon size="13" color="white">mdi-compare-horizontal</v-icon>
        </div>
        <div v-if="item.title" class="ig-caption-overlay">
          <span>{{ item.title }}</span>
        </div>
      </div>
    </div>

    <GalleryLightbox
      v-if="lightboxOpen"
      :items="items"
      :start-index="activeIndex"
      @close="lightboxOpen = false"
    />
  </div>
</template>

<script>
import GalleryLightbox from './GalleryLightbox.vue';

export default {
  name: 'GalleryGrid',
  components: { GalleryLightbox },
  data: () => ({
    lightboxOpen: false,
    activeIndex: 0,
  }),
  computed: {
    items() { return this.$store.state.info.gallery || []; },
  },
  methods: {
    open(idx) {
      this.activeIndex = idx;
      this.lightboxOpen = true;
    },
  },
};
</script>

<style scoped>
.ig-gallery-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 3px;
}
.ig-gallery-item {
  position: relative;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  cursor: pointer;
  background: rgba(var(--v-theme-on-surface), 0.05);
}
.ig-gallery-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.25s;
}
.ig-gallery-item:hover img { transform: scale(1.06); }

.ig-compare-badge {
  position: absolute;
  top: 6px;
  left: 6px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: rgba(0,0,0,0.5);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
}
.ig-caption-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: flex-end;
  padding: 6px;
  background: linear-gradient(to top, rgba(0,0,0,0.55) 0%, transparent 45%);
  opacity: 0;
  transition: opacity 0.2s;
  pointer-events: none;
}
.ig-gallery-item:hover .ig-caption-overlay { opacity: 1; }
.ig-caption-overlay span {
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
